module.exports = __webpack_public_path__ + "static/media/ic-house.48273037.svg";